"use client";

import { useEffect, useState } from "react";

export default function Counter({ target }) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (count < target) {
      const increment = target > 1000 ? 100 : 1;  // büyük sayılar hızlı artar
      const interval = setInterval(() => {
        setCount(prev => {
          if (prev + increment >= target) {
            clearInterval(interval);
            return target;
          }
          return prev + increment;
        });
      }, 20);  // hız
      return () => clearInterval(interval);
    }
  }, [count, target]);

  const formatNumber = () => {
    if (count >= 1000) {
      return `${Math.floor(count / 1000)}K+`;  // 1000 ve üzeri için K+ formatı
    }
    return count;  // 1000'den küçük sayılar olduğu gibi gösterilir
  };

  return (
    <span className="text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl font-bold">
      {formatNumber()}
    </span>
  );
}
